import React from 'react';

const Footer = () => {
  return (
    <footer className="footer-class fixed-bottom text-white text-center py-2" style={{ backgroundColor: "#1ca6af" }}>
      <div className="container">
        <div className="mb-1">Последвайте ни в социалните мрежи</div>
        <div className="social-net d-flex justify-content-center gap-2 mb-1">
          <a href="https://www.tiktok.com/@smartval.bg" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
            <i className="bi bi-tiktok"></i>
          </a>
          <a href="https://www.youtube.com/@smartvalbg" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
            <i className="bi bi-youtube"></i>
          </a>
          <a href="https://www.facebook.com/smartvalbg" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
            <i className="bi bi-facebook"></i>
          </a>
          <a href="https://www.instagram.com/smartvalbg/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
            <i className="bi bi-instagram"></i>
          </a>
        </div>
        <small>&copy; 2025 Smartval.bg All Rights Reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;

 